// ====================================================================
// Theme Settings (CSS)
// ====================================================================

// --------------------------------------------------------------------
// This file should only contain SCSS VARIABLES to be used within
// theme styles and styled-components.
//
// It extends _themeBase and is extended by _theme
// --------------------------------------------------------------------

export default variables => variables;
